'use client';
import * as React from 'react';

/**
 * Context which marks the navigation tree as independent.
 */
export const NavigationIndependentTreeContext = React.createContext(false);
